import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Table, TableHead, TableBody, TableCell, TableRow, Paper } from '@material-ui/core';
import { formatDateTime } from 'src/utils';

const styles = {
    paper: {
        height: "100%"
    },
    table: {
        height: "100%"
    }
}
function StatsTable(props) {
    const { classes } = props;
    const longest = props.data.reduce((acc, data) => {
        acc = data.value > acc.value ? data : acc;
        return acc;
    });
    const shortest = props.data.reduce((acc, data) => {
        acc = data.value < acc.value ? data : acc;
        return acc;
    });
    const mean = Math.round(props.data.reduce((acc, data) => {
        acc = acc + data.value;
        return acc;
    }, props.data[0].value)/props.data.length * 100)/100;
    const data = [
        {name: "Longest Response Time", value: longest.value, date: formatDateTime(longest.datetime, true)},
        {name: "Shortest Response Time", value: shortest.value, date: formatDateTime(shortest.datetime, true)},
        {name: "Average Response Time", value: mean, date: "N/A"},
        ]
    return (
        <Paper className={classes.paper}>
            <Table className={classes.table} size="small" padding="checkbox">
                <TableHead>
                <TableRow>
                    <TableCell>Past 24 hours:</TableCell>
                    <TableCell align="right">Secs</TableCell>
                    <TableCell align="right">Date</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {data.map(row => (
                    <TableRow key={row.name} hover={true}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell align="right">{row.value}</TableCell>
                    <TableCell align="right">{row.date}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </Paper>
        
    )
}

StatsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatsTable);



// WEBPACK FOOTER //
// ./src/components/StatsTable.js